export default [
    {
        name: 'warehouse.stack.index',
        path: '/warehouse/stack/items',
        component: () => import("@/views/modules/warehouse/stack/ItemList.vue"),
    },
    {
        name: 'warehouse.stack.show',
        path: '/warehouse/stack/:item',
        component: () => import("@/views/modules/warehouse/stack/Stack.vue"),
    }
]
